import HeadingView, { HeadingVariant } from "common/views/heading/Heading.view";
import { ImageVariant, ImageView } from "common/views/image/Image.view";
import { Fragment } from "core/components/FragmentProvider";
import moment from "moment";
import User from "./entities/User";
import labelProvider from "./UserDetails.label";
import styled from "styled-components";
import Label from "core/components/label/Label";

const MemberDate = styled.span`
	font-style: italic;
	font-weight: 100;
`;

export interface IUserFragmentProps {
	user: User;
	selectedPropId: any[];
}

const { Labels } = labelProvider;

/**
 * Fragment for username
 */

export const Title: Fragment<IUserFragmentProps> = {
	name: "User name",
	component: ({ user }) => (
		<HeadingView variant={HeadingVariant.H2} viewKey="user.title">{user.firstName} {user.lastName}</HeadingView>
	)
};

/**
 * Fragment for user details Company Address and Date of membership started
 * Todo-
 *    Comapny name and address should bind from graphql queries
 */

export const Company: Fragment<IUserFragmentProps> = {
	name: "Company name",
	enabled: ({ user }) => !!user.properties && user.properties.length > 0,
	component: ({ user,selectedPropId }) => {
		const props = {};
		if(!selectedPropId)
			return null;
		for (const upv of Object.values(user.properties)) {
			if (
				upv.propertyValue &&
				upv.propertyValue.property &&
				selectedPropId.indexOf(upv.propertyValue.property.id) > -1
			) {
				if(upv.propertyValue.value!=null){
					props[upv.propertyValue.property.sortIndex] = upv.propertyValue.value;					
				}
			}
		}

		if (Object.keys(props).length < 1) {
			return null;
		}

		const sortedlist = Object.keys(props).sort((a:string, b:string) => +a - +b);
		const sortedValue = sortedlist.map(id => props[id])
		const userProps = sortedValue.join(' | ');
		return (
			<HeadingView variant={HeadingVariant.H4} viewKey="user.company">
			
				<Label k={`user.props.text.${userProps}`} v="${userProps}" args={{userProps}}></Label>
			</HeadingView>
		);
	}
};

/**
 * Fragment for user date of membership started
 */

export const CreateDate: Fragment<IUserFragmentProps> = {
	name: "Create Date",
	enabled: ({ user }) => !!user.createDate,
	component: ({ user }) => (
		<HeadingView variant={HeadingVariant.H4} viewKey="user.meta"><MemberDate><Labels.createDate args={{ date: moment(user.createDate).format('MM/DD/YY') }} /></MemberDate></HeadingView>
	)
};


export const Avatar: Fragment<IUserFragmentProps> = {
	name: "Avatar",
	component: ({ user }) => (
		<ImageView viewKey="user.avatar" variant={ImageVariant.AVATAR} src={user.avatarUrl} />
	)
};



// WEBPACK FOOTER //
// ./src/panels/userDetails/userFragments.tsx